import { createAsyncInterruptHook, createCollectSyncHook, createSyncHook } from "../hooks";
function initHooks() {
  return {
    onBeforeRender: createAsyncInterruptHook(),
    wrapRoot: createSyncHook(),
    pickContext: createSyncHook(),
    config: createCollectSyncHook()
  };
}
export {
  initHooks
};
